import { render, staticRenderFns } from "./RadioImageButton.vue?vue&type=template&id=2d585722"
import script from "./RadioImageButton.vue?vue&type=script&lang=ts"
export * from "./RadioImageButton.vue?vue&type=script&lang=ts"
import style0 from "./RadioImageButton.vue?vue&type=style&index=0&id=2d585722&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports